import { getShortNumericAmericanDateString } from 'common/source/utilities/dates';

export function getPolicyTermText(policyInfo: CustomerPolicyInfo) {
    const policyEffectiveDate = getShortNumericAmericanDateString(policyInfo.effective_date);
    const policyExpirationDate = getShortNumericAmericanDateString(policyInfo.expiration_date);
    return `From ${policyEffectiveDate} to ${policyExpirationDate}`;
}
